// src/components/Layout/ProtectedAdminRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function ProtectedAdminRoute({ children }) {
  const { currentUser, userRole } = useAuth();

  // If not logged in or not admin, redirect
  if (!currentUser || userRole !== "admin") {
    return <Navigate to="/" replace />;
  }

  return children;
}
